import {
  Button,
  CommentReadIcon,
  CommentUnreadIcon,
  Tooltip,
} from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import { useChangeCommentReadStatus } from '../../hooks/comment';
import type { commentReadStatusType } from '../../models/comment';

type Props = {
  commentId: string;
  readStatus: z.infer<typeof commentReadStatusType>;
};

export const CommentChangeReadStatusButton: FC<Props> = ({
  commentId,
  readStatus,
}) => {
  const { t } = useTranslation();
  const { mutateAsync, isLoading } = useChangeCommentReadStatus(commentId);
  // NOTE: 初期作成時はunknownとなるため、readとunknownの両方を許可する
  const isRead = readStatus === 'read' || readStatus === 'unknown';

  return (
    <Tooltip
      title={isRead ? t('comment.mark-as-unread') : t('comment.mark-as-read')}
    >
      <Button
        disabled={isLoading}
        icon={isRead ? <CommentUnreadIcon /> : <CommentReadIcon />}
        onClick={() => {
          mutateAsync({
            readStatus: isRead ? 'unread' : 'read',
          });
        }}
      />
    </Tooltip>
  );
};
